module.exports = __webpack_public_path__ + "static/media/col1.cbaff793.svg";